import { useEffect, useState } from 'react'
import { useNotificationBar } from 'context/notificationContext'
import { fetchCategorySearchApi } from 'hooks/category-manage'
import { fetchCollectionSearchApi, useCollectionContent } from 'hooks/collection'
import SearchableDropdown from '../carousel/SearchableDropdown'
import { useCategoryContent } from 'hooks/category-manage'
interface Props {
  widget: {
    value: string
    label: string
    code: string
  }
  initialData?: any
  onSave: (payload: any) => void
  onCancel?: () => void
}

const orderOptions = [
  { value: 'DEFAULT', label: 'Default' },
  { value: 'PUBLISH_DATE', label: 'Publish Date' },
  { value: 'MOST_POPULAR', label: 'Most Popular' },
]

// ✅ Helper to safely extract shows from any API shape
const extractShows = (queryData: any): any[] => {
  const data = queryData?.data   // 👈 THIS WAS MISSING

  if (data?.category?.shows) return data.category.shows
  if (data?.collection?.shows) return data.collection.shows

  return []
}

const EpisodeListingWidget = ({ widget, initialData, onSave }: Props) => {
  const notification = useNotificationBar()

  const [categoryId, setCategoryId] = useState('')
  const [collectionId, setCollectionId] = useState('')
  const [shows, setShows] = useState<any[]>([])


  const [categoryOpen, setCategoryOpen] = useState(false)
  const [collectionOpen, setCollectionOpen] = useState(false)

  const [categorySearch, setCategorySearch] = useState('')
  const [collectionSearch, setCollectionSearch] = useState('')

  const [categories, setCategories] = useState<any[]>([])
  const [collections, setCollections] = useState<any[]>([])

  const [selectedCategory, setSelectedCategory] = useState<any>(null)
  const [selectedCollection, setSelectedCollection] = useState<any>(null)

  const [loadingCategory, setLoadingCategory] = useState(false)
  const [loadingCollection, setLoadingCollection] = useState(false)

  const [widgetName, setWidgetName] = useState(initialData?.name || 'Episode Listing');
  const [orderBy, setOrderBy] = useState(initialData?.data?.OrderBy || 'DEFAULT');
  const [selectedShowId, setSelectedShowId] =
    useState(initialData?.data?.Show_Id || '');


  /* Fetch Categories */
  useEffect(() => {
    setLoadingCategory(true);

    fetchCategorySearchApi(categorySearch || '')
      .then((res) => {
        const mapped = res.map((c: any) => ({
          id: c.id,
          label: c.name,
        }));

        setCategories(mapped);

        // ✅ bind label from ID
        if (selectedCategory?.id) {
          const match = mapped.find(m => m.id === selectedCategory.id);
          if (match) setSelectedCategory(match);
        }
      })
      .finally(() => setLoadingCategory(false));
  }, [categorySearch, selectedCategory?.id]);


  /* Fetch Collection */

  useEffect(() => {
    setLoadingCollection(true);

    fetchCollectionSearchApi(collectionSearch || '')
      .then((res) => {
        const mapped = res.map((c: any) => ({
          id: c.id,
          label: c.name,
        }));

        setCollections(mapped);

        // ✅ bind label from ID
        if (selectedCollection?.id) {
          const match = mapped.find(m => m.id === selectedCollection.id);
          if (match) setSelectedCollection(match);
        }
      })
      .finally(() => setLoadingCollection(false));
  }, [collectionSearch, selectedCollection?.id]);



  const categoryContentQuery = useCategoryContent(categoryId || null, {
    enabled: !!categoryId,
  })

  const collectionContentQuery = useCollectionContent(collectionId || null, {
    enabled: !!collectionId,
  })


  useEffect(() => {
    if (!initialData?.data) return;

    if (initialData.data.Category_Id) {
      setCategoryId(initialData.data.Category_Id);
      setSelectedCategory({ id: initialData.data.Category_Id });
    }

    if (initialData.data.Collection_Id) {
      setCollectionId(initialData.data.Collection_Id);
      setSelectedCollection({ id: initialData.data.Collection_Id });
    }
  }, [initialData]);

  useEffect(() => {
    if (!initialData?.data) return;

    if (
      (categoryId && categoryContentQuery.data) ||
      (collectionId && collectionContentQuery.data)
    ) {
      fetchShows();
    }
  }, [categoryId, collectionId, categoryContentQuery.data, collectionContentQuery.data]);



  const fetchShows = () => {
    let showList: any[] = []

    if (selectedCategory && !selectedCollection) {
      showList = extractShows(categoryContentQuery.data)
    }

    if (selectedCollection) {
      showList = extractShows(collectionContentQuery.data)
    }


    if (!showList.length) {
      notification.push({
        message: 'No shows found for selected filter',
        type: 'info',
      })
      setShows([])
      return
    }

    setShows(
      showList.map((item: any) => ({
        id: item.show.id,
        name: item.show.name,
      }))
    )
  }



  const handleSave = () => {
    // if (!selectedCategory && !selectedCollection) {
    //   notification.push({
    //     message: 'Please select Category or Collection',
    //     type: 'error',
    //   })
    //   return
    // }


    const finalData = {
      widget_id: Number(widget.value),
      widget_code: widget?.code,
      name: widgetName,
      widget_type: Number(widget.value),


      data: {
        // keep keys for backend compatibility
        Category_Id: null,
        Collection_Id: null,
        Show_Id: '',

        OrderBy: orderBy, // ✅ ONLY REQUIRED FIELD
        widget_title: ``,
        view_all: false,
        widget_code: widget?.code,
        description: '',
        redirection_to: '',
        redirection_id: '',
        content_type: 'STATIC',
        source_type: 'MANUAL',
        source_id: '',
        content_rule: '',
        widget_items: [],
      },
    }


    onSave(finalData);

    // ✅ SUCCESS NOTIFICATION
    notification.push({
      title: 'Success',
      message: 'Episode widget saved successfully',
      type: 'success',
    })

  }


  const handleCancel = () => {
    setWidgetName('')
    setCategorySearch('')
    setCollectionSearch('')
    setSelectedCategory(null)
    setSelectedCollection(null)
    setCategoryId('')
    setCollectionId('')
    setShows([])
    setSelectedShowId('')
    setOrderBy('Default')
    onSave(initialData || null);
  }

  return (
    <div className="space-y-4">

      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl"> */}
      {/* Widget Name */}
      {/* <div className='flex flex-col gap-1'>
          <label className="text-sm font-medium text-gray-700 dark:text-gray-300">Widget Name</label>
          <input
            value={widgetName}
            onChange={(e) => setWidgetName(e.target.value)}
            className="w-full px-3 py-2 text-sm border rounded-lg
 bg-white text-gray-900 placeholder-gray-400
 focus:ring-2 focus:ring-blue-500
 dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder-gray-500"
          />
        </div> */}
      {/* </div> */}

      {/* Category */}

      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">

        <div className='flex flex-col gap-1'>

          <SearchableDropdown
            label="Category"
            value={selectedCategory?.label || ''}
            options={categories}
            searchValue={categorySearch}
            onSearchChange={setCategorySearch}
            isOpen={categoryOpen}
            onToggle={() => setCategoryOpen((v) => !v)}
            isLoading={loadingCategory}
            isEmpty={false}
            onSelect={(opt) => {
              setSelectedCategory(opt)
              setCategoryId(opt.id)
              setCategoryOpen(false)
            }}
          />



        </div>
      </div> */}

      {/* Collection */}

      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">

        <div className='flex flex-col gap-1'>
          <SearchableDropdown
            label="Collection"
            value={selectedCollection?.label || ''}
            options={collections}
            searchValue={collectionSearch}
            onSearchChange={setCollectionSearch}
            isOpen={collectionOpen}
            onToggle={() => setCollectionOpen((v) => !v)}
            isLoading={loadingCollection}
            isEmpty={collections.length === 0 && !loadingCollection}
            onSelect={(opt) => {
              setSelectedCollection(opt)
              setCollectionId(opt.id)
              setCollectionOpen(false)
            }}
          />


        </div>
      </div> */}


      {/* Submit */}
      {/* {(categoryId || collectionId) && ( */}

      {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">

        <button
          onClick={fetchShows}
          disabled={
            (selectedCategory && categoryContentQuery.isLoading) ||
            (selectedCollection && collectionContentQuery.isLoading)
          }
          className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50"
        >
          Show Listing
        </button>

      </div> */}

      {/* )} */}




      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
        {/* Show List */}
        {shows.length > 0 && (
          <div className='flex flex-col gap-1'>
            <label className="label">Select Show</label>
            <select
              value={selectedShowId}
              onChange={(e) => setSelectedShowId(e.target.value)}
              className="w-full px-3 py-2 text-sm border rounded-lg
 bg-white text-gray-900 placeholder-gray-400
 focus:ring-2 focus:ring-blue-500
 dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder-gray-500"
            >

              <option value="">Select Show</option>
              {shows.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-3xl">
        {/* Order By */}
        <div className='flex flex-col gap-1'>
          <label className="label dark:text-white">Order By</label>
          <select
            value={orderBy}
            onChange={(e) => setOrderBy(e.target.value)}
            className="w-full px-3 py-2 text-sm border rounded-lg
 bg-white text-gray-900 placeholder-gray-400
 focus:ring-2 focus:ring-blue-500
 dark:bg-slate-800 dark:border-slate-600 dark:text-white dark:placeholder-gray-500"
          >
            {orderOptions.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="flex justify-end gap-3 pt-6 mt-6 border-t border-gray-200 dark:border-slate-600">
        <button
          onClick={handleCancel}
          className="px-6 py-2 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
        >
          Cancel
        </button>
        {/* Save */}
        <button onClick={handleSave} className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
          Save
        </button>
      </div>

    </div>
  )
}

export default EpisodeListingWidget
